import React from 'react'
import Restorents from "./Component/Basics/Restorents"
import "./Component/Basics/style.css"
import Usestate from "./Component/Hooks/Usestate"
 
const App = () => {
  return (
    <>
    
<Restorents/>

<Usestate/>

    </>
  )
}

export default App